(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const userCentricsLinks = document.querySelectorAll(".open-user-centrics");
    userCentricsLinks?.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof UC_UI !== "undefined") {
          UC_UI.showSecondLayer('services');
        }
        return false;
      });
    })

    let params = new URL(document.location.toString()).searchParams;
    let openUserCentrics = params?.get("open_uc");
    if (openUserCentrics == 1) {
      let interval = setInterval(() => {
        if (typeof UC_UI !== "undefined") {
          clearInterval(interval);
          UC_UI.showSecondLayer('services');
        }
      }, 1000)
    }
  });
})();